'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GET_RECOMMENDED_CONTENTS_CHANNEL_FAILURE = exports.GET_RECOMMENDED_CONTENTS_CHANNEL_COMPLETE = exports.GET_RECOMMENDED_CONTENTS_CHANNEL_START = exports.GET_RECOMMENDATIONS_PAGINATED_FAILURE = exports.GET_RECOMMENDATIONS_PAGINATED_COMPLETE = exports.GET_RECOMMENDATIONS_PAGINATED_START = exports.GET_RECOMMENDED_CONTENTS_FAILURE = exports.GET_RECOMMENDED_CONTENTS_COMPLETE = exports.GET_RECOMMENDED_CONTENTS_START = undefined;
exports.getRecommendationsPaginated = getRecommendationsPaginated;
exports.getRecommendedContentMetaData = getRecommendedContentMetaData;
exports.getRecommendedContentsChannelMetaData = getRecommendedContentsChannelMetaData;

var _httpService = require('../../helpers/httpService');

var HTTP = _interopRequireWildcard(_httpService);

var _config = require('../../config');

var _logging = require('../lib/app/logging');

var _recommendations = require('../operations/recommendations');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var GET_RECOMMENDED_CONTENTS_START = exports.GET_RECOMMENDED_CONTENTS_START = 'GET_RECOMMENDED_CONTENTS_START';
var GET_RECOMMENDED_CONTENTS_COMPLETE = exports.GET_RECOMMENDED_CONTENTS_COMPLETE = 'GET_RECOMMENDED_CONTENTS_COMPLETE';
var GET_RECOMMENDED_CONTENTS_FAILURE = exports.GET_RECOMMENDED_CONTENTS_FAILURE = 'GET_RECOMMENDED_CONTENTS_FAILURE';

var GET_RECOMMENDATIONS_PAGINATED_START = exports.GET_RECOMMENDATIONS_PAGINATED_START = 'GET_RECOMMENDATIONS_PAGINATED_START';
var GET_RECOMMENDATIONS_PAGINATED_COMPLETE = exports.GET_RECOMMENDATIONS_PAGINATED_COMPLETE = 'GET_RECOMMENDATIONS_PAGINATED_COMPLETE';
var GET_RECOMMENDATIONS_PAGINATED_FAILURE = exports.GET_RECOMMENDATIONS_PAGINATED_FAILURE = 'GET_RECOMMENDATIONS_PAGINATED_FAILURE';

var GET_RECOMMENDED_CONTENTS_CHANNEL_START = exports.GET_RECOMMENDED_CONTENTS_CHANNEL_START = 'GET_RECOMMENDED_CONTENTS_CHANNEL_START';
var GET_RECOMMENDED_CONTENTS_CHANNEL_COMPLETE = exports.GET_RECOMMENDED_CONTENTS_CHANNEL_COMPLETE = 'GET_RECOMMENDED_CONTENTS_CHANNEL_COMPLETE';
var GET_RECOMMENDED_CONTENTS_CHANNEL_FAILURE = exports.GET_RECOMMENDED_CONTENTS_CHANNEL_FAILURE = 'GET_RECOMMENDED_CONTENTS_CHANNEL_FAILURE';
// -------------------------------------------------------------- CONFIGURATION --------------------------------------------------------------

var configuration = void 0;
var config = function config() {
    return !configuration ? _config.Configuration.getConfig() : configuration;
};
var baseUrl = function baseUrl() {
    return config().service.baseUrl;
};

// -------------------------------------------------------------- LOGGING --------------------------------------------------------------

var logger = void 0;
function loggingHelper(msg, attributes) {
    if (!logger) {
        logger = (0, _logging.appLogger)().create('action-recommendations');
    }
    logger.error(msg, attributes);
}

function getheader(state) {
    var header = { 'Content-Type': 'application/json' };

    if (state && state.auth && state.auth.authInfo && state.auth.authInfo.access_token) {
        header.Authorization = 'Token ' + state.auth.authInfo.access_token;
    }

    return header;
}

// ------------------------------------------------------------------ READ CALLS ------------------------------------------------------------------

function getRecommendationsPaginated() {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var category = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var pageNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var pageSize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var g2sAnonymousId = arguments[4];
    var referrerMetadata = arguments[5];

    var reqUrl = baseUrl() + '/recommendations';

    if (type) {
        reqUrl = reqUrl + '?type=' + type;
    }

    if (category) {
        reqUrl = reqUrl + '&category=' + category;
    }

    if (pageNumber) {
        reqUrl = reqUrl + '&pageNumber=' + pageNumber;
    }

    if (pageSize) {
        reqUrl = reqUrl + '&pageSize=' + pageSize;
    }
    if (g2sAnonymousId) {
        reqUrl = reqUrl + '&g2sAnonymousId=' + g2sAnonymousId;
    }
    if (referrerMetadata) {
        reqUrl = reqUrl + '&referrerMetadata=' + referrerMetadata;
    }

    return function (dispatch, getState) {
        dispatch({ type: GET_RECOMMENDATIONS_PAGINATED_START });

        return HTTP.getData(reqUrl).then(function (response) {
            dispatch({ type: GET_RECOMMENDATIONS_PAGINATED_COMPLETE, response: response });
            return response;
        }).catch(function (error) {
            loggingHelper('get recommendations paginated failed', { method: 'getRecommendationsPaginated', callType: 'GET', error: error });
            dispatch({ type: GET_RECOMMENDATIONS_PAGINATED_FAILURE, error: error });
            return error;
        });
    };
}

function getRecommendedContentMetaData(contentKeys) {
    return function (dispatch, getState) {
        var state = getState();
        var stateMetaData = state.recommendations && state.recommendations.contentMetaData ? state.recommendations.contentMetaData : null;
        var finalContentKeys = [];

        if (stateMetaData && stateMetaData.size > 0) {
            (contentKeys || []).forEach(function (item) {
                !stateMetaData.get(item) || !stateMetaData.get(item).hasOwnProperty('title') ? finalContentKeys.push(item) : null;
            });
        } else {
            finalContentKeys = contentKeys;
        }

        if (finalContentKeys.length > 0) {
            dispatch({ type: GET_RECOMMENDED_CONTENTS_START });

            var reqUrl = baseUrl() + '/contents?ids=' + finalContentKeys.join();

            return HTTP.getData(reqUrl).then(function (response) {
                dispatch({
                    type: GET_RECOMMENDED_CONTENTS_COMPLETE,
                    recommendedContents: response,
                    requestedContentKeys: finalContentKeys
                });
                return response;
            }).catch(function (error) {
                loggingHelper('failed to get all recommended contents', { method: 'getRecommendedContentInfo', callType: 'GET', error: error });
                dispatch({ type: GET_RECOMMENDED_CONTENTS_FAILURE, error: error });
                return error;
            });
        }

        return Promise.resolve(state.recommendations.contentMetaData);
    };
}

function getRecommendedContentsChannelMetaData(contentKeys) {
    return function (dispatch, getState) {
        var state = getState();
        var stateMetaData = state.recommendations && state.recommendations.contentMetaData ? state.recommendations.contentMetaData : null;
        var finalContentKeys = [];

        if (stateMetaData && stateMetaData.size > 0) {
            (contentKeys || []).forEach(function (item) {
                !stateMetaData.get(item) || !stateMetaData.get(item).hasOwnProperty('channelKey') ? finalContentKeys.push(item) : null;
            });
        } else {
            finalContentKeys = contentKeys;
        }

        if (finalContentKeys.length > 0) {
            dispatch({ type: GET_RECOMMENDED_CONTENTS_CHANNEL_START });

            var reqUrl = baseUrl() + '/channels?query=contentKey:=' + finalContentKeys.join();

            return HTTP.getData(reqUrl).then(function (response) {
                dispatch({
                    type: GET_RECOMMENDED_CONTENTS_CHANNEL_COMPLETE,
                    channels: response,
                    requestedContentKeys: finalContentKeys
                });
                return response;
            }).catch(function (error) {
                loggingHelper('failed to get all recommended contents channel', { method: 'getRecommendedContentsChannelMetaData', callType: 'GET', error: error });
                dispatch({ type: GET_RECOMMENDED_CONTENTS_CHANNEL_FAILURE, error: error });
                return error;
            });
        }

        return Promise.resolve(state.recommendations.contentMetaData);
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/shared/actions/recommendations.js
// module id = 769
// module chunks = 0